"use strict";
/**
 * @fileoverview Class Validator Proxy
 *
 * This module provides a conditional IsArray,IsString... decorator that adapts to different environments:
 * - In webpack/frontend environments: Uses a no-op decorator to avoid importing backend dependencies
 * - In Node.js/backend environments: Uses the actual class-validator decorators
 *
 * This allows shared interfaces to be used across both frontend and backend code without
 * breaking builds due to missing dependencies.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidateNested = exports.IsString = exports.IsOptional = exports.IsObject = exports.IsNumber = exports.IsEnum = exports.IsDate = exports.IsBoolean = exports.IsArray = void 0;
/**
 * No-op decorator factory that accepts any arguments and does nothing.
 *
 * @param {...any} _args - Arguments (unused, but needed for compatibility).
 * @returns {Function} A no-op property decorator.
 */
const noopDecorator = (..._args) => () => { };
/**
 * Logging error decorator factory that logs an error when class-validator is missing.
 * This decorator emits a warning each time it's used, indicating that API documentation
 * won't be generated due to missing dependencies.
 *
 * @param {...any} _args - Arguments (unused, but needed for compatibility).
 * @returns {Function} A property decorator that logs an error.
 */
const loggingErrorDecorator = (..._args) => () => {
    console.error("class-transformer dependency missing! IsArray,IsObject... decorators not functioning.");
};
/**
 * IsArray decorator - conditionally uses real swagger decorator or no-op fallback.
 * Uses no-op when webpack is detected (frontend), otherwise imports from class-validator.
 */
let IsArray;
exports.IsArray = IsArray;
/**
 * IsBoolean decorator - conditionally uses real swagger decorator or no-op fallback.
 * Uses no-op when webpack is detected (frontend), otherwise imports from class-validator.
 */
let IsBoolean;
exports.IsBoolean = IsBoolean;
/**
 * IsDate decorator - conditionally uses real swagger decorator or no-op fallback.
 * Uses no-op when webpack is detected (frontend), otherwise imports from class-validator.
 */
let IsDate;
exports.IsDate = IsDate;
/**
 * IsEnum decorator - conditionally uses real swagger decorator or no-op fallback.
 * Uses no-op when webpack is detected (frontend), otherwise imports from class-validator.
 */
let IsEnum;
exports.IsEnum = IsEnum;
/**
 * IsNumber decorator - conditionally uses real swagger decorator or no-op fallback.
 * Uses no-op when webpack is detected (frontend), otherwise imports from class-validator.
 */
let IsNumber;
exports.IsNumber = IsNumber;
/**
 * IsObject decorator - conditionally uses real swagger decorator or no-op fallback.
 * Uses no-op when webpack is detected (frontend), otherwise imports from class-validator.
 */
let IsObject;
exports.IsObject = IsObject;
/**
 * IsOptional decorator - conditionally uses real swagger decorator or no-op fallback.
 * Uses no-op when webpack is detected (frontend), otherwise imports from class-validator.
 */
let IsOptional;
exports.IsOptional = IsOptional;
/**
 * IsString decorator - conditionally uses real swagger decorator or no-op fallback.
 * Uses no-op when webpack is detected (frontend), otherwise imports from class-validator.
 */
let IsString;
exports.IsString = IsString;
/**
 * ValidateNested decorator - conditionally uses real swagger decorator or no-op fallback.
 * Uses no-op when webpack is detected (frontend), otherwise imports from class-validator.
 */
let ValidateNested;
exports.ValidateNested = ValidateNested;
// Check if webpack is being used (indicates frontend environment).
if (typeof __webpack_require__ !== "undefined") {
    // Frontend/webpack environment - use no-op.
    exports.IsArray = IsArray = noopDecorator;
    exports.IsBoolean = IsBoolean = noopDecorator;
    exports.IsDate = IsDate = noopDecorator;
    exports.IsEnum = IsEnum = noopDecorator;
    exports.IsNumber = IsNumber = noopDecorator;
    exports.IsObject = IsObject = noopDecorator;
    exports.IsOptional = IsOptional = noopDecorator;
    exports.IsString = IsString = noopDecorator;
    exports.ValidateNested = ValidateNested = noopDecorator;
}
else {
    try {
        // Backend/Node.js environment - use real class-validator decorators.
        const { IsArray: CVIsArray, IsBoolean: CVIsBoolean, IsDate: CVIsDate, IsEnum: CVIsEnum, IsNumber: CVIsNumber, IsObject: CVIsObject, IsOptional: CVIsOptional, IsString: CVIsString, ValidateNested: CVValidateNested, } = require("class-validator");
        exports.IsArray = IsArray = CVIsArray;
        exports.IsBoolean = IsBoolean = CVIsBoolean;
        exports.IsDate = IsDate = CVIsDate;
        exports.IsEnum = IsEnum = CVIsEnum;
        exports.IsNumber = IsNumber = CVIsNumber;
        exports.IsObject = IsObject = CVIsObject;
        exports.IsOptional = IsOptional = CVIsOptional;
        exports.IsString = IsString = CVIsString;
        exports.ValidateNested = ValidateNested = CVValidateNested;
    }
    catch {
        console.warn("ee-nestjs-interfaces is NOT recording Swagger API properties!");
        exports.IsArray = IsArray = loggingErrorDecorator;
        exports.IsBoolean = IsBoolean = loggingErrorDecorator;
        exports.IsDate = IsDate = loggingErrorDecorator;
        exports.IsEnum = IsEnum = loggingErrorDecorator;
        exports.IsNumber = IsNumber = loggingErrorDecorator;
        exports.IsObject = IsObject = loggingErrorDecorator;
        exports.IsOptional = IsOptional = loggingErrorDecorator;
        exports.IsString = IsString = loggingErrorDecorator;
        exports.ValidateNested = ValidateNested = loggingErrorDecorator;
    }
}
